import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import PageHeader from "./-components/PageHeader";
import LoadingPop from "components/popup/LoadingPop";
import { useGetConsoleExpressOrderDetail } from "hooks/console/useGetConsoleExpressOrderDetail";
import { PostExpressOrderRequest, usePostConsoleExpressOrder } from "hooks/console/usePostConsoleExpressOrder";
import { usePutConsoleExpressOrder } from "hooks/console/usePutConsoleExpressOrder";
import { shortcut, toastErrorSyle } from "hooks/utils/util";
import { ReactComponent as ArrowDown } from "assets/morning/icon/arrowDownNavy.svg";
import Method1 from "assets/quick/method1.png";
import Method2 from "assets/quick/method2.png";
import Method3 from "assets/quick/method3.png";
import Method4 from "assets/quick/method4.png";
import Method6 from "assets/quick/method6.png";
import Seo from "components/Seo";

const kindEtc = [
    { label: "1.2t화물", value: "1.2t" },
    { label: "1.4t", value: "1.4t" },
    { label: "1.4t화물", value: "1.4t화물" },
    { label: "11t", value: "11t" },
    { label: "14t", value: "14t" },
    { label: "15t", value: "15t" },
    { label: "18t", value: "18t" },
    { label: "1t", value: "1t" },
    { label: "1t화물", value: "1t화물" },
    { label: "2.5t", value: "2.5t" },
    { label: "25t", value: "25t" },
    { label: "3.5t", value: "3.5t" },
    { label: "4.5t", value: "4.5t" },
    { label: "4.5t축", value: "4.5t축" },
    { label: "4.5t플러스", value: "4.5t플러스" },
    { label: "5t", value: "5t" },
    { label: "8t", value: "8t" },
];

export const kindArray = [
    { label: "오토바이", value: "1", image: Method1 },
    { label: "다마스", value: "2", image: Method2 },
    { label: "라보", value: "3", image: Method3 },
    { label: "벤", value: "4", image: Method4 },
    { label: "트럭", value: "5", image: Method6 },
];
export const payGbnArray = [
    { label: "선불", value: "1" },
    { label: "착불", value: "2" },
    { label: "신용", value: "3" },
    { label: "송금", value: "4" },
    { label: "수금", value: "5" },
];
export const docArray = [
    { label: "편도", value: "1" },
    { label: "왕복", value: "2" },
    { label: "경유", value: "3" },
];
export const sfastArray = [
    { label: "일반", value: "1" },
    { label: "급송", value: "2" },
    { label: "조조", value: "3" },
    { label: "야간", value: "4" },
];
export const itemTypeArray = [
    { label: "서류봉투", value: "1" },
    { label: "소박스", value: "2" },
    { label: "중박스", value: "3" },
    { label: "대박스", value: "4" },
];

const initialFormState = {
    list_no: "",
    c_name: "",
    c_charge_name: "",
    c_dept_name: "",
    c_mobile: "",
    kind: "",
    pay_gbn: "",
    doc: "",
    sfast: "",
    item_type: "",
    s_start: "",
    start_telno: "",
    dept_name: "",
    charge_name: "",
    start_sido: "",
    start_gugun: "",
    start_dong: "",
    start_location: "",
    s_dest: "",
    dest_telno: "",
    dest_dept: "",
    dest_charge: "",
    dest_sido: "",
    dest_gugun: "",
    dest_dong: "",
    dest_location: "",
    reason_desc: "",
    kind_etc: "",
    dtime: "",
};

const ConsoleExpressOrderDetail = () => {
    const navigate = useNavigate();
    const params = useParams();
    const list_no = params.idx;
    const [form, setForm] = useState<PostExpressOrderRequest>(initialFormState); // 입력 중인 값
    const { data, isLoading } = useGetConsoleExpressOrderDetail({
        category: "express",
        list_no: list_no ?? "",
    });
    const { mutate: update } = usePutConsoleExpressOrder();
    const { mutate } = usePostConsoleExpressOrder();

    const { 특송화물인터넷접수 } = shortcut();

    useEffect(() => {
        if (data) {
            setForm({
                list_no: data.list_no.toString(),
                c_name: data.c_name,
                c_charge_name: data.c_charge_name,
                c_dept_name: data.c_dept_name,
                c_mobile: data.c_mobile,
                kind: data.kind,
                pay_gbn: data.pay_gbn,
                doc: data.doc,
                sfast: data.sfast,
                item_type: data.item_type,
                s_start: data.s_start,
                start_telno: data.start_telno,
                dept_name: data.dept_name,
                charge_name: data.charge_name,
                start_sido: data.start_sido,
                start_gugun: data.start_gugun,
                start_dong: data.start_dong,
                start_location: data.start_location,
                s_dest: data.s_dest,
                dest_telno: data.dest_telno,
                dest_dept: data.dest_dept,
                dest_charge: data.dest_charge,
                dest_sido: data.dest_sido,
                dest_gugun: data.dest_gugun,
                dest_dong: data.dest_dong,
                dest_location: data.dest_location,
                reason_desc: data.reason_desc,
                kind_etc: data.kind_etc,
                dtime: data.dtime,
            });
        }
    }, [data]);

    const handleSubmit = () => {
        if (form) {
            mutate(
                {
                    ...form,
                    list_no: form.list_no.toString(),
                },
                {
                    onSuccess: data => {
                        toast.success("성공적으로 전송 되었습니다");
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };
    const handleUpdate = () => {
        if (form) {
            update(
                {
                    ...form,
                    list_no: form.list_no.toString(),
                },
                {
                    onSuccess: data => {
                        toast.success("성공적으로 수정 되었습니다");
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    return (
        <>
            <Seo type="console" pageTitle="특송화물 인터넷접수" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="특송화물 인터넷접수" linkTo={특송화물인터넷접수} />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="flex flex-col gap-10 min-w-[1200px]">
                            <div className="bg-white flex flex-col gap-4 rounded-[20px] py-[24px] px-[40px]">
                                {isLoading ? (
                                    <LoadingPop />
                                ) : (
                                    <>
                                        <figure className="w-full overflow-x-auto">
                                            <table className="w-full border-t border-b min-w-[750px]">
                                                <thead>
                                                    <tr className="border-b">
                                                        <th colSpan={4} className="text-center bg-[#DCE1EC] py-3">
                                                            접수자 정보
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">상호</th>

                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.c_name}
                                                                onChange={e => setForm(prev => ({ ...prev, c_name: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">담당자</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.c_charge_name}
                                                                onChange={e =>
                                                                    setForm(prev => ({ ...prev, c_charge_name: e.target.value }))
                                                                }
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">부서명</th>
                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.c_dept_name}
                                                                onChange={e => setForm(prev => ({ ...prev, c_dept_name: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">연락처</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.c_mobile}
                                                                onChange={e => setForm(prev => ({ ...prev, c_mobile: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <table className="w-full border-t border-b min-w-[750px]">
                                                <thead>
                                                    <tr className="border-b">
                                                        <th colSpan={5} className="text-center bg-[#DCE1EC] py-3">
                                                            배송정보
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">배송수단</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-2 items-center w-full px-4">
                                                                {kindArray.map((item, index) => {
                                                                    const radio = (
                                                                        <label htmlFor={item.label} className="flex items-center gap-2">
                                                                            <input
                                                                                id={item.label}
                                                                                type="radio"
                                                                                name="kind"
                                                                                value={item.value}
                                                                                checked={form.kind === item.value}
                                                                                onChange={e =>
                                                                                    setForm(prev => ({ ...prev, kind: e.target.value }))
                                                                                }
                                                                            />
                                                                            <span className="whitespace-nowrap">{item.label}</span>
                                                                        </label>
                                                                    );

                                                                    return (
                                                                        <div key={index} className="flex-1 flex flex-col gap-2">
                                                                            <figure className="w-[85px] h-[85px] rounded-full bg-[#f9f9f9] flex items-center justify-center">
                                                                                <img src={item.image} alt={item.label} />
                                                                            </figure>

                                                                            {item.label === "트럭" ? (
                                                                                <div className="flex gap-5">
                                                                                    {radio}
                                                                                    <Select
                                                                                        value={form.kind_etc}
                                                                                        onValueChange={value =>
                                                                                            setForm(prev => ({ ...prev, kind_etc: value }))
                                                                                        }
                                                                                    >
                                                                                        <SelectTrigger
                                                                                            className={`relative shadow-none text-[#1B1C1E] text-[16px] flex gap-[10px] rounded-[8px] focus:ring-express max-w-[150px] border border-[#E1E2E4] bg-white`}
                                                                                        >
                                                                                            <SelectValue placeholder="" />
                                                                                            <ArrowDown />
                                                                                        </SelectTrigger>
                                                                                        <SelectContent className="bg-white">
                                                                                            {kindEtc.map((item, index) => (
                                                                                                <SelectItem key={index} value={item.value}>
                                                                                                    {item.label}
                                                                                                </SelectItem>
                                                                                            ))}
                                                                                        </SelectContent>
                                                                                    </Select>
                                                                                </div>
                                                                            ) : (
                                                                                radio
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">배송시간</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-5 items-center w-full py-2 px-4">
                                                                <label htmlFor="오전10시~오후1시" className="flex items-center gap-2">
                                                                    <input
                                                                        id="오전10시~오후1시"
                                                                        type="radio"
                                                                        name="dtime"
                                                                        value="오전10시~오후1시"
                                                                        checked={form.dtime === "오전10시~오후1시"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, dtime: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">오전 10시 ~ 오후 1시</span>
                                                                </label>
                                                                <label htmlFor="오후1시~오후5시" className="flex items-center gap-2">
                                                                    <input
                                                                        id="오후1시~오후5시"
                                                                        type="radio"
                                                                        name="dtime"
                                                                        value="오후1시~오후5시"
                                                                        checked={form.dtime === "오후1시~오후5시"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, dtime: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">오후 1시 ~ 5시</span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">지급방법</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-5 items-center w-full py-2 px-4">
                                                                <label htmlFor="선불" className="flex items-center gap-2">
                                                                    <input
                                                                        id="선불"
                                                                        type="radio"
                                                                        name="pay_gbn"
                                                                        value="1"
                                                                        checked={form.pay_gbn === "1"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, pay_gbn: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">선불</span>
                                                                </label>
                                                                <label htmlFor="착불" className="flex items-center gap-2">
                                                                    <input
                                                                        id="착불"
                                                                        type="radio"
                                                                        name="pay_gbn"
                                                                        value="2"
                                                                        checked={form.pay_gbn === "2"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, pay_gbn: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">착불</span>
                                                                </label>
                                                                <label htmlFor="신용" className="flex items-center gap-2">
                                                                    <input
                                                                        id="신용"
                                                                        type="radio"
                                                                        name="pay_gbn"
                                                                        value="3"
                                                                        checked={form.pay_gbn === "3"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, pay_gbn: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">신용</span>
                                                                </label>
                                                                <label htmlFor="송금" className="flex items-center gap-2">
                                                                    <input
                                                                        id="송금"
                                                                        type="radio"
                                                                        name="pay_gbn"
                                                                        value="4"
                                                                        checked={form.pay_gbn === "4"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, pay_gbn: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">송금</span>
                                                                </label>
                                                                <label htmlFor="수금" className="flex items-center gap-2">
                                                                    <input
                                                                        id="수금"
                                                                        type="radio"
                                                                        name="pay_gbn"
                                                                        value="5"
                                                                        checked={form.pay_gbn === "5"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, pay_gbn: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">수금</span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">배송방법</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-5 items-center w-full py-2 px-4">
                                                                <label htmlFor="편도" className="flex items-center gap-2">
                                                                    <input
                                                                        id="편도"
                                                                        type="radio"
                                                                        name="doc"
                                                                        value="1"
                                                                        checked={form.doc === "1"}
                                                                        onChange={e => setForm(prev => ({ ...prev, doc: e.target.value }))}
                                                                    />
                                                                    <span className="whitespace-nowrap">편도</span>
                                                                </label>
                                                                <label htmlFor="왕복" className="flex items-center gap-2">
                                                                    <input
                                                                        id="왕복"
                                                                        type="radio"
                                                                        name="doc"
                                                                        value="2"
                                                                        checked={form.doc === "2"}
                                                                        onChange={e => setForm(prev => ({ ...prev, doc: e.target.value }))}
                                                                    />
                                                                    <span className="whitespace-nowrap">왕복</span>
                                                                </label>
                                                                <label htmlFor="경유" className="flex items-center gap-2">
                                                                    <input
                                                                        id="경유"
                                                                        type="radio"
                                                                        name="doc"
                                                                        value="3"
                                                                        checked={form.doc === "3"}
                                                                        onChange={e => setForm(prev => ({ ...prev, doc: e.target.value }))}
                                                                    />
                                                                    <span className="whitespace-nowrap">경유</span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">배송선택</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-5 items-center w-full py-2 px-4">
                                                                <label htmlFor="일반" className="flex items-center gap-2">
                                                                    <input
                                                                        id="일반"
                                                                        type="radio"
                                                                        name="sfast"
                                                                        value="1"
                                                                        checked={form.sfast === "1"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, sfast: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">일반</span>
                                                                </label>
                                                                <label htmlFor="급송" className="flex items-center gap-2">
                                                                    <input
                                                                        id="급송"
                                                                        type="radio"
                                                                        name="sfast"
                                                                        value="2"
                                                                        checked={form.sfast === "2"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, sfast: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">급송</span>
                                                                </label>
                                                                <label htmlFor="조조" className="flex items-center gap-2">
                                                                    <input
                                                                        id="조조"
                                                                        type="radio"
                                                                        name="sfast"
                                                                        value="3"
                                                                        checked={form.sfast === "3"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, sfast: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">조조</span>
                                                                </label>
                                                                <label htmlFor="야간" className="flex items-center gap-2">
                                                                    <input
                                                                        id="야간"
                                                                        type="radio"
                                                                        name="sfast"
                                                                        value="4"
                                                                        checked={form.sfast === "4"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, sfast: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">야간</span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">물품종류</th>
                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex gap-5 items-center w-full py-2 px-4">
                                                                <label htmlFor="서류봉투" className="flex items-center gap-2">
                                                                    <input
                                                                        id="서류봉투"
                                                                        type="radio"
                                                                        name="item_type"
                                                                        value="1"
                                                                        checked={form.item_type === "1"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, item_type: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">서류봉투</span>
                                                                </label>
                                                                <label htmlFor="소박스" className="flex items-center gap-2">
                                                                    <input
                                                                        id="소박스"
                                                                        type="radio"
                                                                        name="item_type"
                                                                        value="2"
                                                                        checked={form.item_type === "2"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, item_type: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">소박스</span>
                                                                </label>
                                                                <label htmlFor="중박스" className="flex items-center gap-2">
                                                                    <input
                                                                        id="중박스"
                                                                        type="radio"
                                                                        name="item_type"
                                                                        value="3"
                                                                        checked={form.item_type === "3"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, item_type: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">중박스</span>
                                                                </label>
                                                                <label htmlFor="대박스" className="flex items-center gap-2">
                                                                    <input
                                                                        id="대박스"
                                                                        type="radio"
                                                                        name="item_type"
                                                                        value="4"
                                                                        checked={form.item_type === "4"}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, item_type: e.target.value }))
                                                                        }
                                                                    />
                                                                    <span className="whitespace-nowrap">대박스</span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr className="border-b">
                                                        <th rowSpan={3} className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">
                                                            출발지
                                                        </th>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">상호</th>
                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.s_start}
                                                                onChange={e => setForm(prev => ({ ...prev, s_start: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">연락처</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.start_telno}
                                                                onChange={e => setForm(prev => ({ ...prev, start_telno: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">부서명</th>
                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.dept_name}
                                                                onChange={e => setForm(prev => ({ ...prev, dept_name: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">담당</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.charge_name}
                                                                onChange={e => setForm(prev => ({ ...prev, charge_name: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">주소</th>
                                                        <td colSpan={3} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex flex-col gap-2">
                                                                <div className="grid grid-cols-3 gap-2 px-4">
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            시/도
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.start_sido}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, start_sido: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            구/군
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.start_gugun}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, start_gugun: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            동명
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.start_dong}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, start_dong: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="flex items-center gap-2 px-4">
                                                                    <label htmlFor="" className="whitespace-nowrap">
                                                                        상세주소
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        value={form?.start_location}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, start_location: e.target.value }))
                                                                        }
                                                                        className="border w-full border-box p-2"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr className="border-b">
                                                        <th rowSpan={3} className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">
                                                            도착지
                                                        </th>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">상호</th>
                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.s_dest}
                                                                onChange={e => setForm(prev => ({ ...prev, s_dest: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">연락처</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.dest_telno}
                                                                onChange={e => setForm(prev => ({ ...prev, dest_telno: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">부서명</th>
                                                        <td className="border-r text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.dest_dept}
                                                                onChange={e => setForm(prev => ({ ...prev, dest_dept: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">담당</th>
                                                        <td className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form?.dest_charge}
                                                                onChange={e => setForm(prev => ({ ...prev, dest_charge: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="border-b">
                                                        <th className="font-normal text-[15px] w-[20%] border-r py-2">주소</th>
                                                        <td colSpan={3} className="text-[#666666] text-[15px] px-2 py-2">
                                                            <div className="flex flex-col gap-2">
                                                                <div className="grid grid-cols-3 gap-2 px-4">
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            시/도
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.dest_sido}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, dest_sido: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            구/군
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.dest_gugun}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, dest_gugun: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <label htmlFor="" className="whitespace-nowrap">
                                                                            동명
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={form?.dest_dong}
                                                                            onChange={e =>
                                                                                setForm(prev => ({ ...prev, dest_dong: e.target.value }))
                                                                            }
                                                                            className="border w-full border-box p-2"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="flex items-center gap-2 px-4">
                                                                    <label htmlFor="" className="whitespace-nowrap">
                                                                        상세주소
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        value={form?.dest_location}
                                                                        onChange={e =>
                                                                            setForm(prev => ({ ...prev, dest_location: e.target.value }))
                                                                        }
                                                                        className="border w-full border-box p-2"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr className="border-b">
                                                        <th className="bg-[#f8f8f8] font-normal text-[15px] w-[15%] border-r">특이사항</th>

                                                        <td colSpan={4} className="text-[#666666] text-[15px] px-6 py-2">
                                                            <input
                                                                type="text"
                                                                value={form.reason_desc}
                                                                onChange={e => setForm(prev => ({ ...prev, reason_desc: e.target.value }))}
                                                                className="border w-full border-box p-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </figure>

                                        <div className="flex gap-2 justify-center">
                                            <button
                                                onClick={handleSubmit}
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                            >
                                                전송하기
                                            </button>
                                            <button
                                                onClick={handleUpdate}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                수정하기
                                            </button>
                                            <button
                                                onClick={() => navigate(-1)}
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
};

export default ConsoleExpressOrderDetail;
